import { createStore } from 'vuex';
import request from '@/utils/request';
import { solutionList } from '@/api/solution';

// 在store初始化前从localStorage获取jishiyu-activeMenu
const getStoredActiveMenu = () => {
  try {
    const storedActiveMenu = localStorage.getItem('jishiyu-activeMenu');
    return storedActiveMenu || ''; // 如果没有值则返回空字符串
  } catch (error) {
    console.error('Failed to get jishiyu-activeMenu from localStorage:', error);
    return '';
  }
};

export default createStore({
  state: {
    solutionList: [], // 解决方案列表数据
    solutionLoading: false, // 加载状态
    solutionError: null, // 错误信息
    activeMenu: getStoredActiveMenu(), // 当前激活的导航项
    activeIndex: -1, // 当前激活的导航项索引
  },
  getters: {
    getSolutionList: (state) => state.solutionList,
    isSolutionLoading: (state) => state.solutionLoading,
    getSolutionError: (state) => state.solutionError,
    getActiveNav: (state) => state.activeNav,
    getActiveMenu: (state) => state.activeMenu,
    getActiveIndex: (state) => state.activeIndex,
  },
  mutations: {
    // 设置当前激活的导航项
    SET_ACTIVE_MENU(state, menu) {
      state.activeMenu = menu;
      localStorage.setItem('jishiyu-activeMenu', menu)
    },
    // 设置当前激活的导航项索引
    SET_ACTIVE_INDEX(state, index) {
      state.activeIndex = index;
    },
    // 设置解决方案列表
    SET_SOLUTION_LIST(state, data) {
      state.solutionList = data;
    },
    // 设置加载状态
    SET_SOLUTION_LOADING(state, loading) {
      state.solutionLoading = loading;
    },
    // 设置错误信息
    SET_SOLUTION_ERROR(state, error) {
      state.solutionError = error;
    },
    // 设置当前激活的导航项
    SET_ACTIVE_NAV(state, navName) {
      state.activeNav = navName;
      // 保存到localStorage
      try {
        localStorage.setItem('activeNav', JSON.stringify(navName));
      } catch (error) {
        console.error('保存导航状态失败:', error);
      }
    },
  },
  actions: {
    // 获取解决方案列表
    async fetchSolutionList({ commit }, params = {}) {
      commit('SET_SOLUTION_LOADING', true);
      commit('SET_SOLUTION_ERROR', null);
      
      try {
        // 使用导入的 solutionList 函数
        const response = await solutionList(params);
        
        // 注意：根据request.js中的配置，成功状态码是1
        if (response.code === 1) {
          commit('SET_SOLUTION_LIST', response.data || []);
        } else {
          commit('SET_SOLUTION_ERROR', response.message || '获取解决方案列表失败');
        }
      } catch (error) {
        commit('SET_SOLUTION_ERROR', error.message || '网络错误');
        console.error('获取解决方案列表异常：', error);
      } finally {
        commit('SET_SOLUTION_LOADING', false);
      }
    },
    // 更新激活的导航项
    updateActiveNav({ commit }, navName) {
      commit('SET_ACTIVE_NAV', navName);
    },
  },
  modules: {},
});